import { render, staticRenderFns } from "./DecontarePage.vue?vue&type=template&id=77062e2c&scoped=true"
import script from "./DecontarePage.vue?vue&type=script&lang=js"
export * from "./DecontarePage.vue?vue&type=script&lang=js"
import style0 from "./DecontarePage.vue?vue&type=style&index=0&id=77062e2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77062e2c",
  null
  
)

export default component.exports